module.exports = __webpack_public_path__ + "static/IMG_1597-74fdf3dd0d2db797cc93de2d65f93801.jpg";